const state={
	technician:{
    test:1,
    synchronize_time:null,// 数据同步时间
    //导航数据tabBar
    navTabBar:[
      {
        menu_1:1,
        badge:'',
        name:'业绩',
        active:require("@/assets/images/achievement-active.png"),
        inactive:require("@/assets/images/achievement-inactive.png"),
        link: "achievement"
      },
      {
        menu_2:1,
        badge:'',
        name:'会员管理',
        active:require("@/assets/images/member-active.png"),
        inactive:require("@/assets/images/member-inactive.png"),
        link: "member"
      },
      {
        menu_3:1,
        badge:'',
        name:'比一比',
        active:require("@/assets/images/ranking-active.png"),
        inactive:require("@/assets/images/ranking-inactive.png"),
        link: "ranking"
      },
      {
        menu_4:1,
        badge:'',
        name:'我的',
        active:require("@/assets/images/me-active.png"),
        inactive:require("@/assets/images/me-inactive.png"),
        link: "me"
      }
    ],
    renderBarList:[],//筛选后的导航数据tabBar
    radioMember:{},// 选择的会员信息
    blessing:'',// 祝福语
	}
}
export default state
